import gql from "graphql-tag";

export const UPDATE_USER_TITLE_MUTATION = gql`
  mutation UpdateUserTitle($title: String!) {
    updateUserTitle(title: $title)
  }
`;
